import {
  parseMMDDYYYYDate,
  formatDateTime,
  toYMD,
  formatYmdForDisplay,
} from "../../../common/helpers/time";
import { States } from "../../../common/constants/states";
import cloneDeep from "lodash/cloneDeep";

class InstructorEditController {
  constructor(UserService, $state, UsersModel, FlashService) {
    this.UserService = UserService;
    this.$state = $state;
    this.UsersModel = UsersModel;
    this.FlashService = FlashService;
    this.instructor = UserService.getCurrentUser();
    this.states = States;

    UsersModel.getInstructorByID(this.instructor.id).then((response) => {
      if (
        response.usermeta.license !== "" &&
        response.usermeta.license.hasOwnProperty("expiration_date")
      ) {
        response.usermeta.license.expiration_date = formatDateTime(
          parseMMDDYYYYDate(response.usermeta.license.expiration_date),
          "MM/DD/YYYY",
        );
      }
      // Employment start date is read-only here; format the stored YYYY-MM-DD for display.
      if (response.usermeta.employment_start_date) {
        response.usermeta.employment_start_date = formatYmdForDisplay(
          response.usermeta.employment_start_date,
        );
      }
      this.instructor = response;
    });
  }

  editInstructor(isValid) {
    this.submitted = true;

    if (isValid) {
      const payload = cloneDeep(this.instructor);
      payload.usermeta.license.expiration_date = toYMD(
        parseMMDDYYYYDate(payload.usermeta.license.expiration_date),
      );

      this.UsersModel.updateInstructor(payload)
        .then((response) => {
          this.FlashService.setMessage({
            type: "success",
            message: response.message,
          });
          this.submitted = false;
          this.$state.go("drivecoach.instructor.dashboard");
        })
        .catch((Error) => (this.submitted = false));
    } else {
      this.FlashService.setMessage({
        type: "error",
        message: "Please fill the form.",
      });
    }
  }
}
InstructorEditController.$inject = [
  "UserService",
  "$state",
  "UsersModel",
  "FlashService",
];
export default InstructorEditController;
